import React from "react"
import "./color.css"

function ForwardIcon() {
	return (
		<div className="forward-icon">
			<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
				<title>arrow_forward</title>
				<desc>Created with Sketch.</desc>
				<g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="Outlined" transform="translate(-410.000000, -3436.000000)">
						<g id="Navigation" transform="translate(100.000000, 3378.000000)">
							<g
								id="Outlined-/-Navigation-/-arrow_forward"
								transform="translate(306.000000, 54.000000)"
							>
								<g>
									<polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
									<polygon
										className="color"
										id="🔹-Icon-Color"
										fill="#1D1D1D"
										points="12 4 10.59 5.41 16.17 11 4 11 4 13 16.17 13 10.59 18.59 12 20 20 12"
									></polygon>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		</div>
	)
}

export default ForwardIcon
